import { Box, Divider, Typography } from "@mui/material";

interface Props {
  label: string;
  /** Rango o nota alineada a la derecha (`.cotiz-card-meta`). */
  meta?: string;
  /** Omite el divider superior — usar en la primera sección de la card. */
  first?: boolean;
}

/**
 * Replica `.cotiz-card-h` del diseño: label de la sección en `primary.light` y, a la derecha, el
 * rango permitido. Cada sección, salvo la primera, se separa con un divider.
 */
export const SectionHeaderCotizador = ({ label, meta, first }: Props) => (
  <>
    {!first && <Divider sx={{ my: "22px", borderColor: "#E4E7EC" }} />}
    <Box
      sx={{
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1,
        mb: "14px",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, letterSpacing: "-0.01em", color: "primary.light" }}>
        {label}
      </Typography>
      {meta && (
        <Typography variant="body3" color="text.secondary" sx={{ fontVariantNumeric: "tabular-nums" }}>
          {meta}
        </Typography>
      )}
    </Box>
  </>
);
